export default {"src":"/_next/static/media/3.1.de829edc.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};